// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"component-switch"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12 12C12 14.4853 9.98528 16.5 7.5 16.5C5.01472 16.5 3 14.4853 3 12C3 9.51472 5.01472 7.5 7.5 7.5C9.98528 7.5 12 9.51472 12 12Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M7.5 16.5H16.5C18.9853 16.5 21 14.4853 21 12C21 9.51472 18.9853 7.5 16.5 7.5H7.5M7.5 16.5C5.01472 16.5 3 14.4853 3 12C3 9.51472 5.01472 7.5 7.5 7.5M7.5 16.5C9.98528 16.5 12 14.4853 12 12C12 9.51472 9.98528 7.5 7.5 7.5","strokeWidth":"props.strokeWidth"}}]}]};

const ComponentSwitchIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'component-switch',
    ref,
    icon: element,
  },
));

ComponentSwitchIcon.displayName = 'ComponentSwitchIcon';

export default ComponentSwitchIcon;
